import { useAsyncValue } from "react-router-dom";
import { User } from "types";

export default function useUser() {
  const user = useAsyncValue() as User;
  return user;
}
